import { CreditRequestStatus } from '../enums/DeliveryEnums';

export const UOM_OPTIONS = [
  { value: 'EA', label: 'Each' },
  { value: 'CS', label: 'Case' },
  { value: 'LY', label: 'Layer' },
  { value: 'PL', label: 'Pallet' },
];

export const getCreditRequestValue = (status: string | null | undefined) => {
  switch (status) {
    case CreditRequestStatus.Pending.toString():
      return 'Pending';
    case CreditRequestStatus.Review.toString():
      return 'Review';
    case CreditRequestStatus.Complete.toString():
      return 'Completed';
    default:
      return 'N/A';
  }
};
